import React from 'react';
import {
  MTD_PHASES,
  QUARTERLY_DEADLINES_2026_27,
  formatUkLongDate,
} from '../../compliance/mtdFacts';

const Roadmap = () => {
  const now = new Date();
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const currentLabel = `${months[now.getMonth()]} ${now.getDate()}, ${now.getFullYear()}`;
  const phase1 = MTD_PHASES[0];
  const phase2 = MTD_PHASES[1];
  const q1 = QUARTERLY_DEADLINES_2026_27[0];
  const q2 = QUARTERLY_DEADLINES_2026_27[1];

  const milestones = [
    {
      date: new Date(`${phase1.startDate}T12:00:00`),
      dateLabel: formatUkLongDate(phase1.startDate),
      title: 'Phase 1 — digital record-keeping',
      description: phase1.description
    },
    {
      date: new Date(`${q1.deadline}T12:00:00`),
      dateLabel: q1.label,
      title: 'First quarterly update',
      description: `Q1 2026/27 quarterly update deadline (${q1.label}).`
    },
    {
      date: new Date(`${q2.deadline}T12:00:00`),
      dateLabel: q2.label,
      title: 'Second quarterly update',
      description: `Q2 2026/27 quarterly update deadline (${q2.label}).`
    },
    {
      date: new Date('2027-01-31T12:00:00'),
      dateLabel: '31 January 2027',
      title: 'Final old-style return',
      description: 'Deadline for the 2025/26 Self Assessment return.'
    },
    {
      date: new Date(`${phase2.startDate}T12:00:00`),
      dateLabel: formatUkLongDate(phase2.startDate),
      title: phase2.label,
      description: phase2.description
    }
  ];

  return (
    <div className="w-full max-w-4xl mx-auto bg-slate-900/50 backdrop-blur-xl border border-white/5 rounded-3xl p-8 shadow-2xl my-12">
      <div className="mb-10 text-center">
        <h2 className="text-3xl font-bold text-white mb-4">MTD 2026 Roadmap</h2>
        <div className="inline-block px-3 py-1 bg-amber-500/20 text-amber-400 border border-amber-500/30 rounded font-bold tracking-widest uppercase text-sm">
          Today: {currentLabel}
        </div>
      </div>

      <div className="relative border-l-2 border-indigo-500/30 ml-6 space-y-10 pb-4 pt-2">
        {milestones.map((milestone, index) => {
          const isPast = milestone.date < now;
          const isNext = !isPast && (index === 0 || milestones[index - 1].date < now);

          return (
            <div key={index} className="relative pl-8">
              <div className={`absolute left-[-7px] top-2 w-3 h-3 rounded-full border-2 ${
                isPast ? 'bg-indigo-500 border-indigo-500'
                : isNext ? 'bg-amber-500 border-amber-500 animate-pulse shadow-lg shadow-amber-500/50'
                : 'bg-slate-900 border-slate-600'
              }`}></div>

              <div className={`p-6 rounded-2xl border ${
                isNext ? 'bg-amber-500/10 border-amber-500/30 shadow-lg shadow-amber-500/5'
                : isPast ? 'bg-indigo-500/5 border-indigo-500/20'
                : 'bg-black/20 border-white/5'
              }`}>
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-sm font-bold text-indigo-400">{milestone.dateLabel}</span>
                  {isNext && <span className="px-2 py-0.5 text-[10px] font-bold tracking-widest text-amber-900 bg-amber-500 rounded uppercase">Next</span>}
                  {isPast && <span className="px-2 py-0.5 text-[10px] font-bold tracking-widest text-indigo-300 bg-indigo-500/30 rounded uppercase">Done</span>}
                </div>
                <h3 className="text-lg font-bold text-white mb-1">{milestone.title}</h3>
                <p className="text-xs text-slate-400 leading-relaxed">{milestone.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Roadmap;
